export default {
    one_payment: 'One payment',
    weekly: 'Weekly',
    two_weeks: 'Bi weekly',
    bi_monthly: 'Bimonthly',
    monthly: 'Monthly',
};
